















































import Vue from "vue";
import Component from "vue-class-component";
import AppService from "@/services/AppService";
import App from "@/domain/App";
import Table, { TableRow, TableItem } from "@/components/table/Table.vue";
import DesktopHeader from "@/components/layout/DesktopHeader.vue";
import Popper, { PopperMenuItem } from "@/components/helpers/Popper.vue";
import Avatar from "@/components/util/Avatar.vue";
import Header from "@/components/layout/Header.vue";
import AuthService from "@/services/AuthService";
import NotificationManager from "@/components/notifications/NotificationManager";
import RouteHelper from "@/router/RouteHelper";
import { DateTime } from "luxon";

@Component({
  components: {
    Table,
    TableRow,
    TableItem,
    DesktopHeader,
    Popper,
    PopperMenuItem,
    Avatar,
    Header
  },
  filters: {
    formatTrialDateTime(expiresAt: DateTime) {
      if (expiresAt == null) return "";
      const diffInDays = expiresAt.diffNow("days");
      const daysLeft = diffInDays.toObject().days;
      if (daysLeft == null) {
        return "less than one day";
      }
      return Math.floor(daysLeft) + " days";
    }
  }
})
export default class AppSelection extends Vue {
  async logout() {
    await AuthService.signOut();
    RouteHelper.route_to_name("sign_in");
  }

  toAppSelection() {
    RouteHelper.route_to_name("app_selection");
  }

  get trialUntil() {
    return AuthService.getTrialUntil();
  }
}
